import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseDownloadServiceWithFilter } from './base.service';
import { ComparisonAct } from '@cl/shared/models/comparison-acts/comparison-act.model';
import { Client, CommandResult } from '@cl/shared/models';
import { lastValueFrom } from 'rxjs';
import { ComparisonActFileQuery } from '@cl/shared/models/comparison-acts/comparison-act-file-query.model';
import { FileMetadata } from '@cl/shared/models/file.model';
import { NzImageService } from 'ng-zorro-antd/image';
import { BaseClientNotificationConfiguration } from '@cl/shared/models/base/base-client-notification-configuration.model';
import { ComparisonActFilter } from '@cl/shared/models/comparison-acts/comparison-act-filter.model';

@Injectable({ providedIn: 'root' })
export class ComparisonActsService extends BaseDownloadServiceWithFilter<ComparisonAct, ComparisonActFilter> {
    constructor(
        protected httpClient: HttpClient,
        protected nzImageService: NzImageService,
    ) {
        super(httpClient, '/api/v1/comparison-acts/', nzImageService);
    }

    async sendComparisonActFillNotification(comparisonActNotificationConfig: BaseClientNotificationConfiguration): Promise<CommandResult<void>> {
        return await lastValueFrom(this.httpClient.post<CommandResult<void>>(`${this.baseApiUrl}send-notification`, comparisonActNotificationConfig));
    }

    async extendUrlValidity(comparisonActId: number, extensionDays: number): Promise<CommandResult<void>> {
        return await lastValueFrom(
            this.httpClient.patch<CommandResult<void>>(`${this.baseApiUrl}${comparisonActId}/extend-url-validity/${extensionDays}`, null),
        );
    }

    async downloadComparisonActFile(comparisonActFileQueryParams: ComparisonActFileQuery) {
        return this.handleFileDownloading(
            lastValueFrom(
                this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}comparison-act-file`, {
                    params: new HttpParams({ fromObject: { ...comparisonActFileQueryParams } }),
                }),
            ),
        );
    }

    async downloadComparisonActPrintout(comparisonActId: number): Promise<void> {
        return this.handleGeneratedFileDownload(
            lastValueFrom(
                this.httpClient.get<Blob>(`${this.baseApiUrl}download-printout/${comparisonActId}`, {
                    responseType: 'blob' as 'json',
                    observe: 'response',
                }),
            ),
        );
    }

    async getComparisonActClient(comparisonActId: number): Promise<CommandResult<Client>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<Client>>(`${this.baseApiUrl}${comparisonActId}/client`));
    }
}
